export async function getDataEmployDealerLevel(params: string) {
  if (params) {
    try {
      const response = await fetch(
        `/internal-api/employee/education/employee/dealer/level?${params}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
          credentials: "include",
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Ошибка: ", error);
    }
  }
}
